//#region src/nodey-graph-templates/camera.ts
var e = (e) => ({
	options: {},
	connections: [{
		inputNodeId: "0708230b-31f3-46a5-aa29-77a4ba426a6f",
		outputNodeId: "d110a7bf-09ef-4afa-a9e6-af29c8c2dd63",
		inputName: "image_data",
		outputName: "image_data",
		isEnabled: !0,
		type: "image"
	}],
	frames: [],
	nodes: {
		"d110a7bf-09ef-4afa-a9e6-af29c8c2dd63": {
			id: "d110a7bf-09ef-4afa-a9e6-af29c8c2dd63",
			type: "cinematic-camera",
			customName: "Cinematic Camera",
			position: {
				x: 112.10601032861273,
				y: 389.58921366170296
			},
			collapsed: !1,
			isEnabled: !0,
			io: {
				inputs: e.cinematicCameraComponent ? { camera_id: {
					defined: !0,
					source: { kind: "local" },
					value: e.cinematicCameraComponent.getUniqueId()
				} } : {},
				outputs: {}
			}
		},
		"0708230b-31f3-46a5-aa29-77a4ba426a6f": {
			id: "0708230b-31f3-46a5-aa29-77a4ba426a6f",
			collapsed: !1,
			customName: "Save OKO Image Asset",
			io: {
				inputs: {},
				outputs: {}
			},
			isEnabled: !0,
			position: {
				x: 638.4658385339228,
				y: 326.4211749316174
			},
			type: "io-image-asset-save"
		},
		"f20003a9-859e-4ae4-9485-f5315da793c8": {
			id: "f20003a9-859e-4ae4-9485-f5315da793c8",
			collapsed: !1,
			customName: "Load OKO Image Asset",
			io: {
				inputs: {},
				outputs: {}
			},
			isEnabled: !0,
			position: {
				x: 399.8263527804501,
				y: 664.085423597395
			},
			type: "io-image-asset-load"
		}
	}
});
//#endregion
export { e as cameraNodeyTemplate };
